import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const Impressum = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="bg-black text-white">
        <Navbar />
      </div>
      <div className="bg-gray-50 flex-grow">
        <div className="container mx-auto px-6 py-12">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
            <h1 className="text-3xl font-bold mb-8">Impressum</h1>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">BenefitWerk</h2>
              <p>
                <strong>Geschäftsführung:</strong> BenefitWerk<br />
                <strong>Anschrift:</strong> Eyachstraße 37, 71065 Sindelfingen<br />
                <strong>Telefon:</strong> <a href="tel:+4917681237159" className="text-blue-600 underline">0176 81237159</a><br />
                <strong>E-Mail:</strong> <a href="mailto:info@benefitwerk.de" className="text-blue-600 underline">info@benefitwerk.de</a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Inhaltlich Verantwortlicher</h2>
              <p>
                BenefitWerk (Anschrift wie oben)
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Rechtliche Informationen</h2>
              <p>
                <strong>Erlaubnis:</strong> Nach § 34 d Abs. 1 Gewerbeordnung (Versicherungsmakler)<br />
                <strong>Aufsichtsbehörde:</strong> Industrie- und Handelskammer Region Stuttgart<br />
                Jägerstraße 30, 70174 Stuttgart
              </p>
              <p className="mt-4">
                <strong>Vermittlerregister:</strong><br />
                <a href="https://www.vermittlerregister.info" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">www.vermittlerregister.info</a><br />
                Registrierungs-Nr.: D-OKLU-X2KJ7-59
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Streitbeilegung</h2>
              <p>
                Beschwerdeverfahren via Online-Streitbeilegung für Verbraucher (OS): <a href="https://ec.europa.eu/consumers/odr" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">ec.europa.eu/consumers/odr</a>.<br />
                Wir sind zur Teilnahme am Streitschlichtungsverfahren verpflichtet. Eine Liste mit den Kontaktdaten der anerkannten Streitschlichtungsstellen finden Sie unter der angegebenen Website.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Berufsbezeichnung und Berufskammer</h2>
              <p>
                <strong>Berufsbezeichnung:</strong> Versicherungsmakler mit Erlaubnis nach § 34 d Abs. 1 Gewerbeordnung, Bundesrepublik Deutschland<br />
                <strong>Zuständige Berufskammer:</strong> Industrie- und Handelskammer Region Stuttgart<br />
                Jägerstraße 30, 70174 Stuttgart
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Berufsrechtliche Regelungen</h2>
              <p>Die berufsrechtlichen Regelungen umfassen:</p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li>§ 34 d Gewerbeordnung (GewO)</li>
                <li>Verordnung über die Versicherungsvermittlung und -beratung (VersVermV)</li>
              </ul>
              <p className="mt-4">
                Diese Regelungen können auf der Website <a href="https://www.gesetze-im-internet.de" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">www.gesetze-im-internet.de</a> eingesehen werden.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Nachhaltigkeitsrisiken</h2>
              <p>
                <strong>Definition:</strong> Nachhaltigkeitsrisiken (ESG-Risiken) sind Ereignisse oder Bedingungen aus den Bereichen Umwelt, Soziales und Unternehmensführung, die negative Auswirkungen auf den Wert von Investitionen haben können.
              </p>
              <p className="mt-4">
                <strong>Beispiele:</strong>
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li><strong>Umwelt:</strong> Extremwetterereignisse durch den Klimawandel</li>
                <li><strong>Soziales:</strong> Nichteinhaltung arbeitsrechtlicher Standards</li>
                <li><strong>Unternehmensführung:</strong> Korruption oder mangelnde Steuerehrlichkeit</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">Vergütung und Nachhaltigkeitsfaktoren</h2>
              <p>
                Die Vergütung für die Vermittlung von Finanzprodukten wird grundsätzlich nicht durch Nachhaltigkeitsrisiken beeinflusst. Anbieter, die Nachhaltigkeitsrisiken berücksichtigen, könnten eine höhere Vergütung bieten, sofern dies den Kundeninteressen nicht widerspricht.
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Impressum;